export const INVITATION_KEY_ERROR_MESSAGE = 'INVITATION_KEY_ERROR_MESSAGE';
export const PROCESSING_INVITATION_KEY = 'PROCESSING_INVITATION_KEY';
export const SET_UUID = 'SET_UUID';
export const SET_SUBSCRIPTIONS = 'SET_SUBSCRIPTIONS';
export const FETCH_USER_DETAILS_SUCCESS = 'FETCH_USER_DETAILS_SUCCESS';
export const SAVE_USER_DETAILS_LOADING = 'SAVE_USER_DETAILS_LOADING';



// WEBPACK FOOTER //
// ./src/store/modules/user/types.ts